export interface ContentProcessingResult<TCollection, TItem> {
  collection: TCollection;
  latestItem: TItem | null;
  lockedItem: TItem | null;
  latestTimestamp: number;
  hasLatestContent: boolean;
  hasLockedContent: boolean;
}

export interface ContentProcessingState<T> {
  latestItem: T | null;
  lockedItem: T | null;
  latestTimestamp: number;
  hasLatestContent: boolean;
  hasLockedContent: boolean;
}

export function createProcessingState<T>(): ContentProcessingState<T> {
  return {
    latestItem: null,
    lockedItem: null,
    latestTimestamp: Number(new Date(0)),
    hasLatestContent: false,
    hasLockedContent: false,
  };
}

export function trackLatestAndLocked<T>(
  item: T,
  itemId: string,
  timestamp: number,
  lockedContentId: string | null,
  state: ContentProcessingState<T>
): void {
  if (!state.latestItem) {
    state.latestItem = item;
  }

  if (timestamp > state.latestTimestamp) {
    state.latestTimestamp = timestamp;
    state.latestItem = item;
    state.hasLatestContent = true;
  }

  if (lockedContentId && itemId === lockedContentId) {
    state.lockedItem = item;
    state.hasLockedContent = true;
  }
}
